<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <div class="d-flex space-between">
        <div class="search-bar">
            <app-search (search)="handleSearch($event)"></app-search>
            <div ngbDropdown>
                <button ngbDropdownToggle *ngIf="enableFilters" class="btn btn-filter btn-outline-primary"><i
                        class="bi bi-filter"></i></button>
                <div ngbDropdownMenu>
                    <div id="menuWrap">
                        <div>
                            <div
                                class="filter-header p-4 d-flex justify-content-between align-items-center pt-2 pb-2 border-bottom">
                                <h5>Filters</h5>
                                <button class="btn btn-link p-0 text-decoration-none" (click)="clearFilters()">
                                    Alle filters wissen ({{ getActiveFilterCount() }})
                                </button>
                            </div>

                            <ng-container *ngFor="let filterKey of getFilterKeys()">
                                <div class="filter-section p-4 border-bottom {{ filtersData[filterKey].type }}"
                                    [ngSwitch]="filtersData[filterKey].type">
                                    <div class="mb-2 d-flex justify-content-between align-items-center">
                                        <h6>{{ filtersData[filterKey].label }}</h6>
                                        <button
                                            *ngIf="getActiveFilters()[filtersData[filterKey].label] && (getActiveFilters()[filtersData[filterKey].label].values).length > 0"
                                            class="btn btn-link p-0 text-decoration-none"
                                            (click)="clearFilterSection(filterKey)">Wissen</button>
                                    </div>

                                    <ng-container *ngSwitchCase="'search'">
                                        <input type="text" [placeholder]="filtersData[filterKey].label"
                                            class="form-control" [(ngModel)]="filters[filterKey]"
                                            (ngModelChange)="applyFilters()">
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'range'">
                                        <input lang="nl" type="date" [placeholder]="filtersData[filterKey].label"
                                            class="form-control" [(ngModel)]="filters[filterKey]"
                                            (ngModelChange)="applyFilters()">
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'string'">
                                        <input type="text" [placeholder]="filtersData[filterKey].label"
                                            class="form-control" [(ngModel)]="filters[filterKey]"
                                            (ngModelChange)="applyFilters()">
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'select'">
                                        <div class="form-check pl-0 pb-0"
                                            *ngFor="let optionKey of getOptionKeys(filtersData[filterKey].values)">
                                            <app-custom-checkbox [binding]="isOptionSelected(filterKey, optionKey)"
                                                [label]="filtersData[filterKey].values[optionKey]"
                                                (change)="toggleOption(filterKey, optionKey, $any($event.target).checked)"></app-custom-checkbox>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'boolean'">
                                        <div class="form-check form-switch mt-2 filter-switch">
                                            <input class="form-check-input" type="checkbox" role="switch"
                                                [id]="'filter-' + filterKey" [(ngModel)]="filters[filterKey]"
                                                (ngModelChange)="applyFilters()">
                                        </div>
                                    </ng-container>

                                    <ng-container *ngSwitchDefault>
                                        <input type="text" [placeholder]="filtersData[filterKey].label"
                                            class="form-control" [(ngModel)]="filters[filterKey]"
                                            (ngModelChange)="applyFilters()">
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tagList">
                <ng-container *ngFor="let filterLabel of getFilterLabels()">
                    <div class="tag-group" *ngIf="(getActiveFilters()[filterLabel].values).length > 0">
                        <span class="tag-label">{{ filterLabel }}:</span>
                        <div *ngFor="let value of getActiveFilters()[filterLabel].values">
                            <div class="tag-item cursor-pointer"
                                (click)="removeTag(getActiveFilters()[filterLabel].key, value)">
                                <span class="tag-value">{{ value }}</span>
                                <i class="bi bi-x"></i>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <button class="btn btn-primary" *ngIf="showActionButton" (click)="onButtonClick()"
                [innerHTML]="actionButtonText">
            </button>
        </div>
        <app-pagination [currentPage]="currentPage" [totalPages]="lastPage" [totalItems]="totalItems"
            [itemsPerPage]="itemsPerPage" (pageChange)="handlePageChange($event)">
        </app-pagination>
    </div>

    <table class="table">
        <thead>
            <tr>
                <th (click)="sortKey(col.key)" *ngFor="let col of columnMapping" [scope]="'col'">
                    {{ col.label }}
                    <i *ngIf="sortField == col.key && sortOrder == 'asc'" class="bi bi-caret-up"></i>
                    <i *ngIf="sortField == col.key && sortOrder == 'desc'" class="bi bi-caret-down"></i>
                </th>
                <th width="30"></th>
            </tr>
        </thead>

        <!-- When no sections are defined, show a single section with optional title -->
        <ng-container *ngIf="sections.length === 0; else multipleSections">
            <ng-container *ngIf="title">
                <div class="section-header">{{ title }}</div>
            </ng-container>
            <tbody>
                <tr *ngFor="let item of items">
                    <td [ngClass]="[col.cssClass ? col.cssClass : '', viewURL ? 'cursor-pointer' : '']"
                        (click)="openPage(item)" *ngFor="let col of columnMapping">
                        <ng-container [ngSwitch]="col.type || 'text'">
                            <span *ngSwitchCase="'text'">{{ getNestedValue(item, col.key) }}</span>
                            <span *ngSwitchCase="'email'">{{ item[col.key] }}</span>
                            <span *ngSwitchCase="'monetary'">{{ formatToDutchEuro(item[col.key]) }}</span>
                            <span *ngSwitchCase="'date'">{{ formatToDutchDate(item[col.key]) }}</span>
                            <span *ngSwitchCase="'dateTime'">{{ item[col.key] | dutchDateTime }}</span>
                            <span *ngSwitchCase="'simpleDateTime'">{{ formatToDutchDateTime(item[col.key]) }}</span>
                            <span *ngSwitchCase="'organisation'">
                                <span *ngIf="item['organisation']">{{ item['organisation'][col.key] }}</span>
                            </span>
                            <span *ngSwitchCase="'role'">{{ item[col.key]['name'] }}</span>
                            <span *ngSwitchCase="'multi'"><ng-container *ngIf="item[col.key][0]">{{
                                    item[col.key][0].title }}</ng-container></span>
                            <span *ngSwitchCase="'boolStatus'">
                                <ng-container *ngIf="item[col.key] == '1'">Actief</ng-container>
                                <ng-container *ngIf="item[col.key] != '1'">Inactief</ng-container>
                            </span>
                            <span *ngSwitchCase="'boolYesNo'">
                                <ng-container *ngIf="item[col.key] == '1'">Ja</ng-container>
                                <ng-container *ngIf="item[col.key] != '1'">Nee</ng-container>
                            </span>
                            <span *ngSwitchCase="'enum'">
                                <span [innerHTML]="col.enum[item[col.key]]"></span>
                            </span>
                            <span *ngSwitchCase="'statusText'">
                                <span [innerHTML]="item[col.key] | status"></span>
                            </span>
                        </ng-container>
                    </td>
                    <td>
                        <div ngbDropdown class="d-inline-block">
                            <button type="button" class="btn-table-dropdown" ngbDropdownToggle>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                    <path
                                        d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                </svg>
                            </button>
                            <div ngbDropdownMenu *ngIf="items">

                                <button *ngFor="let customActionButton of customActionButtons"
                                    (click)="handleComponent(customActionButton, item)" ngbDropdownItem>
                                    {{customActionButton['title']}}
                                </button>

                                <button *ngIf="openModalComponent" (click)="openModal(item)" ngbDropdownItem>
                                    Wijzig
                                </button>
                                <button (click)="delete(item)" ngbDropdownItem>
                                    Verwijder
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </ng-container>

        <!-- Multiple sections template -->
        <ng-template #multipleSections>
            <ng-container *ngFor="let section of sections; index as i">
                <div class="section-header" *ngIf="i != 0">{{ section.title }}</div>
                <tbody>
                    <tr *ngFor="let item of getItemsForSection(section.title)">
                        <td [ngClass]="{'cursor-pointer': viewURL}" (click)="openPage(item)"
                            *ngFor="let col of columnMapping">
                            <ng-container [ngSwitch]="col.type || 'text'">
                                <span *ngSwitchCase="'text'">{{ getNestedValue(item, col.key) }}</span>
                                <span *ngSwitchCase="'date'">{{ getNestedValue(item, col.key) | dutchDate }}</span>
                                <span *ngSwitchCase="'monetary'">{{ formatToDutchEuro(item[col.key]) }}</span>
                                <span *ngSwitchCase="'multi'"><ng-container *ngIf="item[col.key][0]">{{
                                        item[col.key][0].title }}</ng-container></span>
                                <span *ngSwitchCase="'boolStatus'">
                                    <ng-container *ngIf="item[col.key] == '1'">Actief</ng-container>
                                    <ng-container *ngIf="item[col.key] != '1'">Inactief</ng-container>
                                </span>
                                <span *ngSwitchCase="'revokeStatus'">
                                    <ng-container *ngIf="item[col.key] == '1'">Ja</ng-container>
                                    <ng-container *ngIf="item[col.key] != '1'">Nee</ng-container>
                                </span>
                                <span *ngSwitchCase="'statusText'">
                                    <span [innerHTML]="item[col.key] | status"></span>
                                </span>
                            </ng-container>
                        </td>
                        <td>
                            <div ngbDropdown class="d-inline-block">
                                <button type="button" class="btn-table-dropdown" ngbDropdownToggle>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                        <path
                                            d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                    </svg>
                                </button>
                                <div ngbDropdownMenu>
                                    <button *ngIf="openModalComponent" (click)="openModal(item)"
                                        ngbDropdownItem>Wijzig</button>
                                    <button (click)="delete(item)" ngbDropdownItem>Verwijder</button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </ng-container>
        </ng-template>
    </table>
</div>
